module.exports = __webpack_public_path__ + "img/SKMJ_sheet1.92ed60cc.png";